(function () {
	if (typeof document.createElement('input').placeholder !== 'undefined') {
		return;
	}
	
	const _inputs = document.querySelectorAll('[placeholder]');
	
	function init() {
		let _container;
		let _placeholderInput;
		
		for (let i = 0, length = _inputs.length; i < length; i++) {
			_container = document.createElement('span');
			_container.style.position = 'relative';
			_container.style.display = 'block';
			
			_inputs[i].parentNode.insertBefore(_container, _inputs[i]);
			_container.appendChild(_inputs[i]);
			
			_placeholderInput = _inputs[i].cloneNode();
			_placeholderInput.name = '';
			_placeholderInput.removeAttribute('data-placeholder');
			
			if (_placeholderInput.type) {
				_placeholderInput.type = 'text';
			}
			
			_placeholderInput.style.position = 'absolute';
			_placeholderInput.style.top = 0;
			_placeholderInput.style.left = 0;
			_placeholderInput.value = _inputs[i].getAttribute('placeholder');
			util.addClass(_placeholderInput, 'placeholder');
			_placeholderInput.addEventListener('focus', focus, true);
			
			_container.appendChild(_placeholderInput);
			
			_inputs[i].addEventListener('blur', blur, true);
		}
	}
	
	function blur() {
		if (this.value === '') {
			this.nextElementSibling.style.display = '';
		}
	}
	
	function focus() {
		this.previousElementSibling.focus();
		this.style.display = 'none';
	}
	
	init();
}());